import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";

const EMPTY = { world: "street", name_tr: "", name_en: "", desc_tr: "", desc_en: "", price: 0, tag: "", images: [], sizes: [], order: 0 };

const Field = ({ label, children }) => (
  <label className="block">
    <span className="f-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">{label}</span>
    <div className="mt-1">{children}</div>
  </label>
);

const inputCls = "w-full border border-zinc-300 bg-white px-3 py-2 text-sm text-zinc-900 outline-none focus:border-zinc-900";

export const ProductForm = ({ open, onOpenChange, initial, onSave }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setF({ ...EMPTY, ...(initial || {}) });
  }, [open, initial]);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = {
      world: f.world, name_tr: f.name_tr, name_en: f.name_en, desc_tr: f.desc_tr, desc_en: f.desc_en,
      price: Number(f.price) || 0, tag: f.tag, order: Number(f.order) || 0,
      images: (Array.isArray(f.images) ? f.images : String(f.images).split("\n")).map((s) => s.trim()).filter(Boolean),
      sizes: (Array.isArray(f.sizes) ? f.sizes : String(f.sizes).split(",")).map((s) => s.trim()).filter(Boolean),
    };
    await onSave(body);
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="admin-product-dialog" className="max-w-2xl max-h-[90vh] overflow-y-auto bg-[#faf7f1] text-zinc-900 rounded-none">
        <DialogHeader><DialogTitle className="f-serif italic text-3xl font-normal">{initial?.id ? "Ürünü düzenle" : "Yeni ürün"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid grid-cols-2 gap-4">
          <Field label="Dünya">
            <select data-testid="admin-form-world" value={f.world} onChange={set("world")} className={inputCls}>
              <option value="street">Streetwear</option>
              <option value="oldmoney">Old Money</option>
            </select>
          </Field>
          <Field label="Fiyat (₺)"><input data-testid="admin-form-price" type="number" min="0" value={f.price} onChange={set("price")} className={inputCls} required /></Field>
          <Field label="Ad (TR)"><input data-testid="admin-form-name-tr" value={f.name_tr} onChange={set("name_tr")} className={inputCls} required /></Field>
          <Field label="Name (EN)"><input data-testid="admin-form-name-en" value={f.name_en} onChange={set("name_en")} className={inputCls} required /></Field>
          <Field label="Açıklama (TR)"><textarea data-testid="admin-form-desc-tr" rows={3} value={f.desc_tr} onChange={set("desc_tr")} className={inputCls} /></Field>
          <Field label="Description (EN)"><textarea data-testid="admin-form-desc-en" rows={3} value={f.desc_en} onChange={set("desc_en")} className={inputCls} /></Field>
          <Field label="Etiket"><input data-testid="admin-form-tag" value={f.tag} onChange={set("tag")} className={inputCls} /></Field>
          <Field label="Sıra"><input data-testid="admin-form-order" type="number" value={f.order} onChange={set("order")} className={inputCls} /></Field>
          <div className="col-span-2"><Field label="Bedenler (virgülle)"><input data-testid="admin-form-sizes" value={Array.isArray(f.sizes) ? f.sizes.join(", ") : f.sizes} onChange={set("sizes")} className={inputCls} /></Field></div>
          <div className="col-span-2"><Field label="Görsel URL'leri (her satıra bir tane)"><textarea data-testid="admin-form-images" rows={3} value={Array.isArray(f.images) ? f.images.join("\n") : f.images} onChange={set("images")} className={inputCls} /></Field></div>
          <button data-testid="admin-form-submit" disabled={busy} className="col-span-2 h-12 rounded-full bg-zinc-900 text-white f-mono text-[12px] uppercase tracking-[0.25em] disabled:opacity-60">{busy ? "..." : "Kaydet"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
